import { useState } from "react";
import { fetchLinkDetails } from "../services/apiService";
export const useHome = () => {
  const [isFetching, setIsFetching] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchLinkDetailsForHome = async (callback: any) => {
    setIsLoading(true);
    setIsFetching(true);

    try {
      const response = await fetchLinkDetails();
      await callback(response);
    } catch (error) {
      console.error(error);
    }

    setIsFetching(false);
    setIsLoading(false);
  };

  return {
    isFetching,
    isLoading,
    fetchLinkDetailsForHome,
  };
};
